import {reqWithToken} from './requestHelper';

export async function getNews(all = false){
    return (await reqWithToken('api/pebooking/news',{
        params:{all}
    })).data;
}

export async function updateNews(news){
    return (await reqWithToken('api/pebooking/news',{
        data: news,
        method: 'put'
    })).data;
}

export async function insertNews(news){
    return (await reqWithToken('api/pebooking/news',{
        data: news,
        method: 'post'
    })).data;
}

export async function deleteNews(id){
    return (await reqWithToken('api/pebooking/news',{
        params: {id},
        method: 'delete'
    })).data;
}

